import React, { useContext } from "react";
import { Avatar } from "@mui/material";
import { Context } from "../ChatPanel/ChatContext";
import { ITopic, MessageTypes, TopicTypes } from "../../types"
import { StyledBadge } from "../styledBadge";
import { useAtomInstance, useAtomSelector, useAtomState, useAtomValue } from "@zedux/react";
import { activeTopicAtom } from "../../atoms/atoms";
import { isUserOnlineSelector, onlineUsersAtom } from '../../atoms/onlineUsersAtom';
import { firstLetter } from "../../functions/firstLetter";
import { userByIdSelector } from "../../atoms/userListAtom";
import { convert_to_fa } from "@src/functions/farsi";
import { EmptyShareContent, ISharedAtomState } from "@src/atoms/shareContentAtom";

const LastMessageTexts = {
    [MessageTypes.IMAGE]: 'تصویر',
    [MessageTypes.VOICE]: 'پیام صوتی',
    [MessageTypes.FILE]: 'فایل',
    [MessageTypes.VIDEO]: 'ویدئو',
    [MessageTypes.OBJECT]: 'نیدباکس',
}

export default function TopicItem({ topic, className, onClick, guests, sharedContent }: { topic: ITopic, onClick?: () => void, className?: string, guests?: number[], sharedContent?: ISharedAtomState }) {
    const { topic_id, topic_type, other_display, topic_name, avatar_url,
        last_message_text, last_message_deleted, last_message_type, unseen_count, other_user_id } = topic

    // const unseen_count = 15
    const { context } = useContext(Context)
    const [activeTopicID, setActiveTopicID] = useAtomState(activeTopicAtom, [context])

    const isUserOnline = useAtomValue(isUserOnlineSelector, [other_user_id])
    const is_online = (topic_type != TopicTypes.CHANNEL && topic_type != TopicTypes.GROUP && other_user_id != null && isUserOnline)

    const otherUserInfo = useAtomSelector(userByIdSelector, other_user_id as number)

    const isGuest = Array.isArray(guests) && other_user_id && guests.includes(other_user_id)

    const titleName = (topic_type == TopicTypes.CHANNEL || topic_type == TopicTypes.GROUP) ? topic_name : otherUserInfo?.fullname || other_display || topic_name
    const avatarUrl = (topic_type == TopicTypes.CHANNEL || topic_type == TopicTypes.GROUP) ? avatar_url : otherUserInfo?.avatar_url || avatar_url


    return <div
        className={`hover:bg-neutral-20 flex flex-row justify-between p-2 cursor-pointer border-b ${className} border-b-neutral-40 border-r-2 ${topic_id == activeTopicID ? "border-r-primary-00" : 'border-r-transparent'}`}
        onClick={() => {
            if (sharedContent !== EmptyShareContent) {
                
            } else {
                setActiveTopicID(topic_id)
            }

            // Unused
            if (!!onClick) {
                onClick()
            }
        }}

    >
        <div className="relative w-8 h-8">
            <div className='absolute inset-0 m-auto rounded-full w-full max-w-10 h-full max-h-10 -translate-y-1'>
                <StyledBadge
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    invisible={!is_online}
                    color="success" variant="dot" overlap="circular"
                >
                    {
                        topic_type == TopicTypes.CHANNEL || topic_type == TopicTypes.GROUP ?
                            <Avatar className="rounded-full" src={avatar_url ?? ''}>
                                {firstLetter(titleName)}
                            </Avatar> :
                            <Avatar className="rounded-full" src={avatar_url ?? ''}>
                                {firstLetter(other_display)}
                            </Avatar>
                    }

                </StyledBadge>
            </div>
        </div>
        <div className="flex flex-col mr-10 grow">
            <div className='font-semibold'>
                {titleName} 
                {isGuest && <span className="font-light text-neutral-80 text-xxs"> (مهمان)</span>}
            </div>

            <div className='font-light text-neutral-900 text-xs line-clamp-2'>
                {last_message_deleted ? 'پیام حذف شده' : (LastMessageTexts[last_message_type] || last_message_text || 'برای شروع پیام دهید')}
            </div>

        </div>
        {Boolean(unseen_count && unseen_count > 0) &&
            <div className="flex items-center">
                <div className="items-center content-center bg-info-00 mr-auto px-2 py-1 rounded-full text-white text-sm align-middle min-w-7 text-center">{convert_to_fa(unseen_count)}</div>
            </div>}
    </div>
}

